import { Link } from "react-router-dom";
import HeroBreadcrumb from "@/components/layout/HeroBreadcrumb";
import { ExternalLink } from "lucide-react";

const PARTNER = [
  {
    nome: "50&Più Enasco Roma",
    sito: "http://www.50epiuenasco.it/",
    logo: "/logo-50piu.webp",
    desc: "Istituto di Patronato e di Assistenza Sociale, nato all'interno di Confcommercio-Imprese per l'Italia. Tutela i cittadini garantendo gratuitamente assistenza e consulenza per tutte le prestazioni pensionistiche erogate dagli istituti previdenziali.",
  },
  {
    nome: "CIOL Lazio - Centro Impresa OnLine",
    sito: "https://www.seac.it/soluzioni/servizi-b2b/servizi-al-territorio/",
    logo: "/logo-ciol.webp",
    desc: "Eroga servizi alle imprese in ambito contabile, fiscale e normativa del lavoro. Svolge consulenza su check-up aziendale, business plan e riorganizzazione, avvalendosi di software SEAC per la gestione di cedolini e dichiarazioni dei redditi.",
  },
  {
    nome: "EBIT Lazio",
    sito: "http://ebitlazio.it/",
    logo: "/logo-ebit.webp",
    desc: "Ente Bilaterale Territoriale del Lazio, costituito pariteticamente dalle Associazioni territoriali di Confcommercio Roma, Filcams Cgil, Fisascat Cisl, Uiltucs. Gestisce formazione, sicurezza, welfare e mercato del lavoro nel settore terziario.",
  },
  {
    nome: "Finpromoter",
    sito: "https://www.finpromoter.it/",
    logo: "/logo-finpromoter.png",
    ctaExtra: { label: "Scopri i servizi", url: "https://www.finpromoter.it/i-nostri-servizi" },
    desc: "Società finanziaria di Confcommercio dedicata al sostegno delle micro, piccole e medie imprese e dei professionisti. Intermediario finanziario vigilato da Banca d'Italia, può erogare direttamente credito e finanziamenti a tasso agevolato.",
  },
  {
    nome: "Fon.Te.",
    sito: "https://www.fondofonte.it/",
    logo: "/logo-fonte.webp",
    desc: "Fondo pensione complementare a capitalizzazione per i lavoratori del commercio, del turismo e dei servizi. Forma di previdenza per l'erogazione di trattamenti pensionistici complementari del sistema obbligatorio.",
  },
  {
    nome: "Fondo For.Te.",
    sito: "https://www.fondoforte.it/",
    logo: "/logo-forte.webp",
    desc: "Fondo paritetico per la formazione continua dei dipendenti delle aziende del settore terziario: commercio, turismo, servizi, logistica, spedizioni e trasporto. Non ha fini di lucro e promuove Piani formativi aziendali e territoriali.",
  },
  {
    nome: "Sanimpresa",
    sito: "http://www.sanimpresa.it/",
    logo: "/logo-sanimpresa.webp",
    desc: "Cassa di Assistenza Sanitaria Integrativa per gli addetti delle imprese del Terziario, Distribuzione e Servizi, istituita nel 2003 da Confcommercio Roma e le Organizzazioni Sindacali. Integra l'attività del SSN con rimborso delle spese sanitarie.",
  },
  {
    nome: "CFMT – Centro di Formazione Management del Terziario",
    sito: "https://www.cfmt.it/",
    logo: "/logo-cfmt.png",
    desc: "Centro di formazione continua per i dirigenti del terziario, istituito da Confcommercio e Manageritalia. Offre corsi, master, eventi, learning path, podcast e strumenti di welfare dedicati allo sviluppo manageriale e professionale.",
  },
  {
    nome: "FONDIR – Fondo Paritetico Interprofessionale",
    sito: "https://www.fondir.it/",
    logo: "/logo-fondir.png",
    desc: "Fondo paritetico interprofessionale riconosciuto dal Ministero del Lavoro che finanzia e promuove la Formazione Continua dei dirigenti. Da vent'anni fa crescere le aziende: 7.000 imprese aderenti, 33.000 dirigenti formati e 38 milioni di euro di contributi nel 2026.",
  },
];

export default function PartnerPage() {
  return (
    <main id="main-content" data-testid="partner-page">
      <section className="bg-[var(--confcom-blue)] py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <HeroBreadcrumb />
          <h1 className="text-4xl md:text-5xl font-bold text-white font-['Encode_Sans_Semi_Condensed'] tracking-tight">Partner</h1>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {PARTNER.map((p) => (
              <div
                key={p.nome}
                className="rounded-xl border border-[var(--confcom-border)] overflow-hidden flex flex-col"
                data-testid={`partner-${p.nome.toLowerCase().replace(/[\s&.]/g, "-")}`}
              >
                {/* Logo */}
                <div className="bg-white flex items-center justify-center px-8 py-6 h-36 border-b border-[var(--confcom-border)]">
                  <img src={p.logo} alt={`Logo ${p.nome}`} className={`object-contain ${["Finpromoter", "CFMT – Centro di Formazione Management del Terziario", "FONDIR – Fondo Paritetico Interprofessionale"].includes(p.nome) ? "max-h-16 max-w-[180px]" : "max-h-28 max-w-[240px]"}`} loading="lazy" />
                </div>

                {/* Content */}
                <div className="p-5 flex flex-col flex-1">
                  <h2 className="text-base font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-3">{p.nome}</h2>
                  <p className="text-sm text-[var(--confcom-text-secondary)] leading-relaxed flex-1">{p.desc}</p>
                  <div className="flex items-center gap-3 mt-4 flex-wrap">
                    <a href={p.sito} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-xs font-medium text-[var(--confcom-blue)] hover:underline">
                      Sito web <ExternalLink size={11} aria-hidden="true" />
                    </a>
                    {p.ctaExtra && (
                      <a href={p.ctaExtra.url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-xs font-medium bg-[var(--confcom-blue)] text-white px-3 py-1.5 rounded-md hover:opacity-90 transition-opacity">
                        {p.ctaExtra.label} <ExternalLink size={11} aria-hidden="true" />
                      </a>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
